export const POLL_THEME_VARIABLES = {
  colors: {
    primary: {
      description: 'Основной текст внутри опроса',
      name: 'Основной текст в опросе',
    },
    primary_on_accent: {
      description: "Галочка внутри чекбокса, точка внутри радиокнопки, цвет внутри главной кнопки 'ответить'",
      name: 'Элементы на акцентном цвете',
    },
    secondary: {
      description: 'Цвет плейсхолдера у инпутов, селектов, иконка перетаскивания у ранжирования',
      name: 'Подсказки, лейблы',
    },
    tertiary: {
      description:
        'Цвет прогресс-бара, иконки, третичные тексты маленьким шрифтом, лейблы задизейбленных кнопок, дисклеймеры',
      name: 'Мелкий текст, подписи',
    },
    background_base: {
      description: 'Фон опроса',
      name: 'Фон опроса',
    },
    background_base_alt: {
      description: 'Альтернативный фон при ховерах на ответах, рейтингах и других второстепенных сущностях',
      name: 'Второстепенный фон',
    },
    background_neutral_1: {
      description: 'Фон textarea и всех инпутов, фон ховера айтема в дропдауне, фон загрузки файла',
      name: 'Поля ввода',
    },
    background_neutral_1_hover: {
      description: 'Ховер textarea и всех инпутов, фон кнопки "выбрать" в конджойнте, фон полосы рейтинга "слайдеров"',
      name: 'Поля ввода при наведении',
    },
    background_neutral_2: {
      description: 'Фон неактивного чекбокса и радиокнопки',
      name: 'Неактивные переключатели',
    },
    background_evaluation_1: {
      description: 'Фон шторок выпадающих списков, модальных окон, карточек, дропдауна, попапа в кликмапе',
      name: 'Всплывающие элементы',
    },
    action: {
      description:
        'Цвет кнопки "закрыть" на мобильной версии, зона DND, активная карточка в конджойнте, цвет ссылок и текста кнопки "пропустить"',
      name: 'Активные элементы',
    },
    action_hover: {
      description: 'Цвет при ховере на action элементы (например, markdown ссылка)',
      name: 'При наведении ',
    },
    accent: {
      description: 'Акцентный цвет (желтый), используется в аудио, чекбоксах, радиокнопках и акцентных компонентах',
      name: 'Основной акцентный ',
    },
    accent_hover: {
      description: 'Цвет при ховере на акцентные элементы',
      name: 'Акцентный при наведении',
    },
    accent_active: {
      description: 'Цвет при нажатии на акцентные элементы',
      name: 'Акцентный при нажатии',
    },
    accent_2: {
      description:
        'Второй акцентный синий цвет, используется в медиафайле аудио, кнопка "сохранить" в карте кликов, бордер загрузки файлов',
      name: 'Второй акцентный',
    },
    accent_2_hover: {
      description: 'Цвет при наведении на элементы (заменяется там, где это предусмотрено)',
      name: 'Второй акцент. при наведении',
    },
    accent_2_active: {
      description: 'Цвет при нажатии на элементы (заменяется там, где это предусмотрено)',
      name: 'Второй акцент. при нажатии',
    },
    negative: {
      description: 'Цвет текста ошибки, цвет лайка',
      name: 'Текст ошибок',
    },
    negative_pale: {
      description: 'Фон блоков с ошибками, цвет фона таймера при строгом таймере, фон рейтинга "дизлайк"',
      name: 'Фон блоков с ошибками',
    },
    negative_pale_hover: {
      description: 'Фон блоков с ошибками при ховере там, где это предусмотрено',
      name: 'Фон ошибок при наведении',
    },
    positive: {
      description: 'Цвет текста успеха',
      name: 'Текст успеха',
    },
    positive_pale: {
      description: 'Фон блоков с успехом, фон рейтинга "лайк"',
      name: 'Фон успеха при наведении',
    },
    info_pale: {
      description: 'Фон активного таймера, фон дроп-зоны в карточной сортировке',
      name: 'Информационный фон',
    },
    warning_pale: {
      description: 'Фон завершённого таймера',
      name: 'Предупреждающий фон',
    },
    progress_bar_line: {
      description: 'Незаполненная линия прогресс-бара',
      name: 'Незаполненная линия',
    },
    progress_bar_line_filled: {
      description: 'Заполненная линия прогресс-бара',
      name: 'Заполненная линия',
    },
    border_normal: {
      description: 'Цвет всех рамок в опросе',
      name: 'Все обводки',
    },
    border_focus: {
      description: 'Цвет рамки при фокусе на textarea',
      name: 'Обводка при фокусе',
    },
    border_hover: {
      description: 'Цвет рамки при ховере на конджоинт карточку в десктопной версии',
      name: 'Обводка при наведении',
    },
  },
  others: {
    survey_elements_border_radius: {
      description: 'Скругления всех элементов внутри опроса',
      name: 'Survey Elements Border Radius',
    },
    survey_container_border_radius_desktop: {
      description: 'Внешние скругления общего контейнера опроса на десктопе',
      name: 'Desktop Container Border Radius',
    },
    survey_container_border_radius_mobile: {
      description: 'Внешние скругления общего контейнера опроса на телефоне (при ширине менее 599px)',
      name: 'Mobile Container Border Radius',
    },
    survey_container_inner_padding_desktop: {
      description: 'Внутренний отступ опроса до границы на десктопе',
      name: 'Desktop Container Inner Padding',
    },
    survey_container_inner_padding_mobile: {
      description: 'Внутренний отступ опроса до границы на телефоне (при ширине менее 599px)',
      name: 'Mobile Container Inner Padding',
    },
  },
  fonts: {
    font_heading_survey_title: {
      description: 'Шрифт заголовка опроса',
      name: 'Desktop Survey Title Font',
    },
    font_heading_page_title: {
      description: 'Шрифт заголовка страницы',
      name: 'Desktop Page Title Font',
    },
    font_text_body: {
      description: 'Шрифт заголовков вопросов, финального и начального экрана',
      name: 'Desktop Heading Body Font',
    },
    font_text_main: {
      description: 'Шрифт основных элементов в опросе',
      name: 'Desktop Main Text Font',
    },
    font_text_hints: {
      description: 'Шрифт подсказок и прочих второстепенных элементов',
      name: 'Desktop Hints Text Font',
    },
    font_text_micro_hints: {
      description: 'Шрифт третьестепенных элементов, футера на начальном и финальном экране',
      name: 'Desktop Micro Hints Text Font',
    },
    font_text_main_ui: {
      description: 'Шрифт в кнопках, используется в карточной сортировке и матрице',
      name: 'Desktop Main UI Text Font',
    },
  },
  logotype: {
    logotype_src: {
      description: 'Ссылка на логотип',
    },
    logotype_link: {
      description: 'Ссылка при клике на логотип',
    },
  },
} as const;

export const WEBVIEW_THEME_VARIABLES = {
  colors: {
    primary: {
      description: 'Цвет основного текст внутри опроса',
      name: 'Основной текст в опросе',
    },
    primary_on_accent: {
      description: "Галочка внутри чекбокса, цвет внутри главной кнопки 'ответить'",
      name: 'Элементы на акцентном цвете',
    },
    secondary: {
      description: 'Цвет плейсхолдера у инпутов, подсказки у рейтингов',
      name: 'Подсказки, лейблы',
    },
    tertiary: {
      description: 'Третичные тексты маленьким шрифтом',
      name: 'Мелкий текст, подписи',
    },
    background_base: {
      description: 'Фон опроса',
      name: 'Фон опроса',
    },
    background_base_alt: {
      description: 'Незаполненные звезды, смайлы, фон инпутов при фокусе',
      name: 'Второстепенный фон',
    },
    background_neutral_1: {
      description: 'Фон textarea и всех инпутов, фон ховера айтема в дропдауне',
      name: 'Поля ввода',
    },
    background_neutral_1_hover: {
      description: 'Ховер textarea и всех инпутов',
      name: 'Поля ввода при наведении',
    },
    background_neutral_2: {
      description: 'Фон ответов',
      name: 'Фон ответов',
    },
    action: {
      description: 'Цвет кнопки "закрыть", цвет кнопки назад, ссылки',
      name: 'Активные элементы',
    },
    accent: {
      description: 'Акцентный цвет (желтый), используется в аудио, чекбоксах, радиокнопках и акцентных компонентах',
      name: 'Основной акцентный',
    },
    accent_hover: {
      description: 'Цвет при ховере на акцентные элементы',
      name: 'Акцентный при наведении',
    },
    accent_active: {
      description: 'Цвет при нажатии на акцентные элементы',
      name: 'Акцентный при нажатии',
    },
    positive: {
      description: 'Цвет текста успеха',
      name: 'Текст успеха',
    },
    negative: {
      description: 'Цвет текста ошибки',
      name: 'Текст ошибки',
    },
    progress_bar_line: {
      description: 'Незаполненная линия прогресс-бара',
      name: 'Незаполненная линия',
    },
    progress_bar_line_filled: {
      description: 'Заполненная линия прогресс-бара',
      name: 'Заполненная линия',
    },
    border_normal: {
      description: 'Цвет всех рамок в опросе',
      name: 'Все обводки',
    },
  },
  others: {
    webview_answer_inner_padding: {
      name: 'Отступ внутри ответа',
      description: 'Внутренний отступ внутри ответа',
    },
    webview_answer_border_radius: {
      name: 'Радиус скругления ответов',
      description: 'Скругления ответов (будет видно если есть кастомный цвет фона ответов)',
    },
    webview_footer_button_position: {
      name: 'Расположение кнопки "ответить"',
      description:
        'Настройка расположения кнопки: кнопка может быть прикреплена либо к нижней части опроса, либо к нижней части экрана',
    },
    webview_elements_border_radius: {
      name: 'Скругления элементов',
      description: 'Скругления элементов чекбокс, ответ неприменимо, поля ввода',
    },
  },
} as const;

export const DIALOG_THEME_VARIABLES = {
  colors: {
    primary: {
      description: 'Основной текст внутри опроса',
      name: 'Основной текст в опросе',
    },
    primary_on_accent: {
      description: "Галочка внутри чекбокса, точка внутри радиокнопки, цвет внутри главной кнопки 'ответить'",
      name: 'Элементы на акцентном цвете',
    },
    secondary: {
      description: 'Цвет плейсхолдера у инпутов, селектов, иконка перетаскивания у ранжирования',
      name: 'Подсказки, лейблы',
    },
    background_base: {
      description: 'Фон опроса',
      name: 'Фон опроса',
    },
    background_base_alt: {
      description: 'Фон ответов одиночного и множественного выбора',
      name: 'Второстепенный фон',
    },
    background_neutral_1: {
      description: 'Фон textarea и всех инпутов, фон ховера айтема в дропдауне, фон загрузки файла',
      name: 'Поля ввода',
    },
    background_neutral_1_hover: {
      description: 'Ховер textarea и всех инпутов, фон кнопки "выбрать" в конджойнте, фон полосы рейтинга "слайдеров"',
      name: 'Поля ввода при наведении',
    },
    background_neutral_2: {
      description: 'Фон неактивного чекбокса',
      name: 'Неактивные переключатели',
    },
    action: {
      description:
        'Цвет кнопки "закрыть" на мобильной версии, зона DND, активная карточка в конджойнте, цвет ссылок и текста кнопки "пропустить"',
      name: 'Активные элементы',
    },
    border_normal: {
      description: 'Цвет всех рамок в опросе',
      name: 'Все обводки',
    },
    accent: {
      description: 'Акцентный цвет (желтый), используется в аудио, чекбоксах, радиокнопках и акцентных компонентах',
      name: 'Основной акцентный',
    },
    progress_bar_line: {
      description: 'Незаполненная линия прогресс-бара',
      name: 'Незаполненная линия',
    },
    progress_bar_line_filled: {
      description: 'Заполненная линия прогресс-бара',
      name: 'Заполненная линия',
    },
  },
} as const;
